import * as React from "react";
import { isJapanese } from "../../HelperSrc";
import { lang } from "../../lang";
import { store } from "../../store/ui";
import { observer } from "mobx-react";
import * as HelperSrc from "../../HelperSrc";

@observer
class Loader extends React.Component {
    public render() {
        return (
            <>
                {(() => {
                    const html: JSX.Element[] = [];

                    const adWorkingStatus = localStorage.getItem(`${HelperSrc.LABEL}_ad_working_status`);

                    if (!store.loaded || adWorkingStatus) {
                        html.push(
                            <div key="loader" className="loader" {...this.props}>
                                <div className="hor">
                                    <div className="sqr" />
                                    <div className="sqr" />
                                    <div className="sqr" />
                                    <div className="sqr" />
                                </div>
                                <div className={`text ${isJapanese("KPMG NBB") || isJapanese(lang.loading) ? "japanese" : ""}`}>
                                    {lang.loading || "KPMG NBB"}
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </>
        );
    }
}

export { Loader };
